import {
  Box,
  Typography,
  IconButton,
  Badge,
  Avatar,
  useTheme,
} from "@mui/material";
import React from "react";
import CloseIcon from "@mui/icons-material/Close";
import { getColorProfile } from "../../../utils/getColorProfile";
// import useCustomTheme from "../../../hooks/useCustomTheme";
// import RenderProfileImage from "../../../component/RenderProfileImage";

const TopBarChatContactWindow = ({
  isAdded,
  handleCloseChatWindowChild,
  selectedContact,
}) => {
  //   const themebody = useCustomTheme();

  const useDetails = selectedContact?.user_detail || selectedContact?.sender;

  const profileImage = useDetails?.profile_pic;
  const fullName = `${useDetails?.first_name ?? ""} ${
    useDetails?.last_name ?? ""
  }`;
  const themebody = useTheme()?.palette?.primary;
  const status = selectedContact?.sender?.status;

  return (
    <>
      <Box
        sx={{
          height: "55px",
          background: themebody?.whitecolor,
          borderTopLeftRadius: 8,
          borderTopRightRadius: 8,
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          pl: 2,
        }}
      >
        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          {isAdded ? (
            <Badge
              sx={{
                "& .MuiBadge-badge": {
                  backgroundColor:
                    status && status === "ONLINE"
                      ? themebody?.sucesscolor
                      : status === "OFFLINE"
                      ? themebody?.warningdarkcolor
                      : themebody?.warningdarkcolor,
                  color:
                    status && status === "ONLINE"
                      ? themebody?.sucesscolor
                      : status === "OFFLINE"
                      ? themebody?.warningdarkcolor
                      : themebody?.warningdarkcolor,
                  boxShadow: `0 0 0 2px`,
                  "&::after": {
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "50%",
                    animation: "ripple 1.2s infinite ease-in-out",
                    border: "1px solid currentColor",
                    content: '""',
                  },
                },
                "@keyframes ripple": {
                  "0%": {
                    transform: "scale(.8)",
                    opacity: 1,
                  },
                  "100%": {
                    transform: "scale(2.4)",
                    opacity: 0,
                  },
                },
              }}
              overlap="circular"
              anchorOrigin={{
                vertical: "bottom",
                horizontal: "right",
              }}
              variant="dot"
            >
              <Avatar
                variant="contained"
                alt={useDetails?.firstName}
                src={profileImage !== "undefined" && `${profileImage}`}
                sx={{
                  fontSize: "16px",
                  width: "32px",
                  height: "32px",
                  background: getColorProfile({
                    firstName: useDetails?.firstName,
                    lastName: useDetails?.last_name,
                  }),
                }}
              >
                {useDetails?.first_name[0]?.toUpperCase() +
                  useDetails?.last_name[0]?.toUpperCase()}
              </Avatar>
            </Badge>
          ) : (
            <Avatar
              variant="contained"
              alt={useDetails?.firstName}
              src={profileImage !== "undefined" && `${profileImage}`}
              sx={{
                fontSize: "16px",
                width: "32px",
                height: "32px",
                background: getColorProfile({
                  firstName: useDetails?.first_name,
                  lastName: useDetails?.last_name,
                }),
              }}
            >
              {useDetails?.first_name[0]?.toUpperCase() +
                useDetails?.last_name[0]?.toUpperCase()}
            </Avatar>
          )}
          <div>
            <Typography
              variant="body2"
              sx={{
                fontSize: 14,
                color: themebody?.textColor,
              }}
            >
              {fullName}
            </Typography>
            <Typography
              variant="body2"
              sx={{
                fontSize: 10,
                color: themebody?.textColor,
              }}
            >
              {selectedContact?.sender?.user_type &&
                `${selectedContact?.sender?.user_type}`}
            </Typography>
          </div>
        </Box>
        <IconButton
          onClick={() => {
            handleCloseChatWindowChild(false);
          }}
        >
          <CloseIcon
            sx={{
              fill: themebody?.textColor,
            }}
          />
        </IconButton>
      </Box>
    </>
  );
};

export default TopBarChatContactWindow;
